import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { createInstrumentApi } from "../../../services/CalibrationService";
import { Modal } from "react-bootstrap";

const AddInstrument = ({ handleAfterCreate }) => {
  const [dataInput, setDataInput] = useState({
    instrument_name: "",
    serial_number: "",
    description: "",
    photo: null,
  });
  const [errors, setErrors] = useState({});
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const openModal = () => setShowModal(true);

  const closeModal = () => {
    setDataInput({
      instrument_name: "",
      serial_number: "",
      description: "",
      photo: null,
    });
    setErrors({});
    setShowModal(false);
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      setDataInput((prevDataInput) => ({
        ...prevDataInput,
        [name]: files[0], 
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      setDataInput((prevDataInput) => ({ ...prevDataInput, [name]: value }));
    }
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitLoading(true);
      const formData = new FormData(); 
      formData.append("instrument_name", dataInput.instrument_name);
      formData.append("serial_number", dataInput.serial_number);
      formData.append("description", dataInput.description);
      formData.append("photo", dataInput.photo);

      const response = await createInstrumentApi(formData); 
      handleAfterCreate(response.data.results); 
      toast.success(response.data.message);
      navigate("/calibration");
      closeModal();
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <>
      <button className="btn btn-primary mx-2" onClick={openModal}>
        Add Instrument
      </button>
      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Instrument</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-2">
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="form-label">
                  Instrument Name<span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  placeholder="Enter Instrument Name"
                  name="instrument_name"
                  value={dataInput.instrument_name}
                  onChange={handleChange}
                />
                {errors.instrument_name && (
                  <div className="text-danger">{errors.instrument_name}</div>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="form-label">
                  Serial Number<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="serial_number"
                  placeholder="Enter Serial No."
                  value={dataInput.serial_number}
                  onChange={handleChange}
                />
                {errors.serial_number && (
                  <div className="text-danger">{errors.serial_number}</div>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="form-label">
                  Description<span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  name="description"
                  placeholder="Enter Description"
                  value={dataInput.description}
                  onChange={handleChange}
                ></textarea>
                {errors.description && (
                  <div className="text-danger">{errors.description}</div>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="form-label">
                  Photo<span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="photo"
                  onChange={handleChange}
                />
                {errors.photo && (
                  <div className="text-danger">{errors.photo}</div>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-start">
            <button
              type="button"
              className="btn btn-primary me-3"
              onClick={handleSubmit}
              disabled={isSubmitLoading}
            >
              {isSubmitLoading ? "Submitting..." : "Submit"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddInstrument;
